export const ADD_PERSONA_AUDIENCE = "ADD_PERSONA_AUDIENCE";
export const ADD_CONTENT_TYPE_LIST = "ADD_CONTENT_TYPE_LIST";
export const ADD_VEEVA_SPECILTY_LIST = "ADD_VEEVA_SPECILTY_LIST";
export const ADD_PERSONA_AUDIENCE_LIST = "ADD_PERSONA_AUDIENCE_LIST";
export const ADD_PERSONA_GROUP = "ADD_PERSONA_GROUP";
export const ADD_PERSONA_GROUP_LIST = "ADD_PERSONA_GROUP_LIST";
export const ADD_COUNTRY = "ADD_COUNTRY";
